import reducer from "./reducers";

import * as encounterAction from "./actions";

export { encounterAction };

export default reducer;
